var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "vue-content-loading",
    {
      attrs: {
        width: 1000,
        height: 200,
        speed: 2,
        "primary-color": "#f3f3f3",
        "secondary-color": "#ecebeb",
      },
    },
    [
      _c("rect", {
        attrs: {
          x: "82",
          y: "119",
          rx: "3",
          ry: "3",
          width: "176",
          height: "12",
        },
      }),
      _vm._v(" "),
      _c("rect", {
        attrs: {
          x: "81",
          y: "49",
          rx: "3",
          ry: "3",
          width: "140",
          height: "11",
        },
      }),
      _vm._v(" "),
      _c("rect", {
        attrs: {
          x: "87",
          y: "139",
          rx: "3",
          ry: "3",
          width: "53",
          height: "11",
        },
      }),
      _vm._v(" "),
      _c("rect", {
        attrs: {
          x: "448",
          y: "120",
          rx: "3",
          ry: "3",
          width: "505",
          height: "11",
        },
      }),
      _vm._v(" "),
      _c("rect", {
        attrs: {
          x: "447",
          y: "43",
          rx: "3",
          ry: "3",
          width: "350",
          height: "11",
        },
      }),
      _vm._v(" "),
      _c("rect", {
        attrs: {
          x: "79",
          y: "18",
          rx: "3",
          ry: "3",
          width: "140",
          height: "11",
        },
      }),
      _vm._v(" "),
      _c("rect", {
        attrs: {
          x: "444",
          y: "16",
          rx: "3",
          ry: "3",
          width: "535",
          height: "11",
        },
      }),
      _vm._v(" "),
      _c("rect", {
        attrs: {
          x: "449",
          y: "144",
          rx: "3",
          ry: "3",
          width: "505",
          height: "11",
        },
      }),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }